import { render, staticRenderFns } from "./PresentationConfig.vue?vue&type=template&id=40355106"
import script from "./PresentationConfig.vue?vue&type=script&lang=js"
export * from "./PresentationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports